module.exports = __webpack_public_path__ + "static/podwojnie-2-cff12b2e6e92aa5d5a700b989f97b02f.jpg";